// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-page {
  max-width: 1080px;
  margin: 0 auto;
  padding: 26px 20px 60px;
  color: #232137;
}

.ops-page button, .ops-page a, .ops-dialog button, .ops-dialog a {
  -webkit-tap-highlight-color: transparent;
}
.ops-page button, .ops-dialog button {
  font: inherit;
  cursor: pointer;
}
.ops-page button:disabled, .ops-dialog button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ops-page button:focus-visible, .ops-page a:focus-visible, .ops-dialog button:focus-visible, .ops-dialog a:focus-visible {
  outline: 3px solid #596cf0;
  outline-offset: 3px;
}

.ops-page .ops-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.ops-page .ops-heading h1 {
  margin: 0 0 4px;
  font-size: clamp(22px, 2.4vw, 32px);
  line-height: 1.15;
}
.ops-page .ops-heading p {
  margin: 0;
  color: #6f7890;
  font-size: 13px;
  line-height: 1.4;
}

.ops-back {
  color: #6f7890;
  text-decoration: none;
  font-size: 14px;
}

.ops-refresh, .ops-close {
  flex: 0 0 auto;
  border: 0;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  background: #f0f2f6;
  color: #232137;
  font-size: 28px !important;
}

.ops-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.ops-hero, .ops-risk {
  min-width: 0;
  border: 1px solid #e4e8ed;
  border-radius: 18px;
  padding: 18px;
  background: white;
}

.ops-eyebrow {
  color: #6f7890;
  font-size: 11px;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.ops-money {
  display: block;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.15;
  letter-spacing: -0.5px;
  overflow-wrap: anywhere;
}

.ops-money-unavailable {
  font-size: 16px;
  line-height: 1.35;
  letter-spacing: 0;
}

.ops-trend {
  display: inline-block;
  color: #187449;
  background: #eef9f2;
  font-size: 12px;
  line-height: 1.4;
  padding: 3px 6px;
  border-radius: 6px;
  margin-top: 8px;
}
.ops-trend.negative {
  color: #b21d38;
  background: #fff0f2;
}

.ops-plan {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin: 12px 0 6px;
  font-size: 13px;
  line-height: 1.4;
}

.ops-progress {
  height: 5px;
  background: #edf0f3;
  border-radius: 5px;
  overflow: hidden;
}
.ops-progress span {
  display: block;
  height: 100%;
  background: #e72f44;
  border-radius: inherit;
}

.ops-page .ops-risk {
  background: #fff5f6;
  border-color: #f8dde2;
}
.ops-page .ops-risk p {
  color: #6f7890;
  font-size: 13px;
  line-height: 1.4;
  margin: 8px 0 0;
  max-width: 360px;
}

.ops-text-button {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  border: 0;
  background: transparent;
  color: #b61b36;
  font-size: 13px !important;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.ops-freshness {
  color: #6f7890;
  font-size: 11px;
  line-height: 1.4;
  margin: 8px 0 12px;
}

.ops-source, .ops-error {
  background: #fff7e5;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.ops-error {
  color: #a71933;
  background: #fff0f2;
}

.ops-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 16px 0 8px;
}
.ops-section-heading h2 {
  font-size: 20px;
  margin: 0;
}
.ops-section-heading h2 span {
  color: #6f7890;
  margin-left: 5px;
}
.ops-section-heading .ops-primary {
  flex: 0 0 auto;
}

.ops-primary, .ops-secondary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 12px 18px;
  min-height: 44px;
  border-radius: 12px;
  font: inherit;
  font-size: 14px;
  text-decoration: none;
  border: 0;
  line-height: 1.3;
}

.ops-primary {
  background: #e72f44;
  color: white;
}

.ops-secondary {
  background: #f0f2f6;
  color: #232137;
}

.ops-filters {
  display: flex;
  gap: 6px;
  overflow: auto;
  padding: 0 0 8px;
}
.ops-filters button {
  flex: 0 0 auto;
  min-height: 44px;
  border: 1px solid #e4e8ed;
  background: white;
  color: #6f7890;
  border-radius: 12px;
  padding: 8px 12px;
  font-size: 13px;
}
.ops-filters button.active {
  background: #232137;
  color: white;
  border-color: #232137;
}

.ops-list {
  display: grid;
  gap: 8px;
}

.ops-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  text-align: left;
  padding: 20px;
  border: 1px solid #e4e8ed;
  border-radius: 18px;
  background: white;
  color: #232137;
  transition: border-color 0.15s;
}
.ops-card:hover {
  border-color: #e72f44;
}

.ops-icon {
  display: grid;
  place-items: center;
  flex: 0 0 44px;
  height: 44px;
  border-radius: 14px;
  background: #fff0f2;
  color: #ba1c39;
  font-size: 24px;
  font-weight: bold;
}

.ops-card-shift .ops-icon {
  background: #fff4db;
  color: #936500;
}

.ops-card-support .ops-icon {
  background: #edf0ff;
  color: #4454b4;
}

.ops-card-copy {
  flex: 1 1;
  min-width: 0;
}
.ops-card-copy strong {
  display: block;
  font-size: 16px;
  margin-bottom: 5px;
}
.ops-card-copy span, .ops-card-copy small {
  display: block;
  font-size: 13px;
  line-height: 1.5;
  color: #6f7890;
  overflow-wrap: anywhere;
}

.ops-card-end {
  display: flex;
  align-items: center;
  gap: 16px;
}
.ops-card-end b {
  font-size: 14px;
  white-space: nowrap;
}
.ops-card-end > span {
  color: #6f7890;
  font-size: 25px;
}

.ops-state {
  padding: 36px 20px;
  border: 1px dashed #dce1e8;
  border-radius: 18px;
  text-align: center;
  background: #fafbfd;
  color: #6f7890;
  line-height: 1.5;
}

.ops-backdrop {
  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: rgba(13, 38, 63, 0.4);
}

.ops-dialog .timetable-input-group:not(.timetable-checkbox-row) {
  gap: 8px;
}
.ops-dialog .timetable-input-group:not(.timetable-checkbox-row) label {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  align-items: stretch;
}
.ops-dialog .timetable-input-group:not(.timetable-checkbox-row) input[type=time] {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 0;
}

.ops-dialog {
  width: 100%;
  max-width: 780px;
  max-height: 90dvh;
  overflow: auto;
  background: #fff;
  color: #232137;
  padding: 26px;
  border-radius: 24px;
  box-shadow: 0 24px 80px rgba(13, 38, 63, 0.2);
}
.ops-dialog header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}
.ops-dialog header h2 {
  margin: 0;
  font-size: 23px;
}
.ops-dialog p {
  line-height: 1.6;
}
.ops-dialog .ops-detail-lead {
  font-size: 19px;
}
.ops-dialog .ops-detail-risk {
  color: #b61b36;
}

.ops-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0;
}

.ops-candidates {
  border-top: 1px solid #e4e8ed;
  margin-top: 24px;
  padding-top: 8px;
}
.ops-candidates article {
  border: 1px solid #e4e8ed;
  border-radius: 16px;
  padding: 16px;
  margin: 12px 0;
}
.ops-candidates article p {
  color: #6f7890;
  margin: 8px 0;
}
.ops-candidates article .ops-actions {
  margin-bottom: 0;
}

.ops-review {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-top: 1px solid #e4e8ed;
  margin-top: 24px;
  padding-top: 18px;
  color: #6f7890;
}

.ops-method {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 18px;
  border-radius: 14px;
  background: #f7f9fa;
}
.ops-method dt {
  color: #6f7890;
}
.ops-method dd {
  margin: 0;
  text-align: right;
}

@media (max-width: 620px) {
  .ops-page {
    padding: 20px 14px 40px;
  }
  .ops-page .ops-heading {
    margin-bottom: 12px;
  }
  .ops-page .ops-heading h1 {
    font-size: clamp(21px, 6vw, 26px);
  }
  .ops-page .ops-heading p {
    font-size: 12px;
  }
  .ops-grid {
    gap: 10px;
  }
  .ops-hero, .ops-risk {
    padding: 14px;
    border-radius: 16px;
  }
  .ops-eyebrow {
    margin-bottom: 6px;
    font-size: 10px;
  }
  .ops-money {
    font-size: clamp(21px, 6.4vw, 26px);
  }
  .ops-money-unavailable {
    font-size: 16px;
  }
  .ops-trend {
    font-size: 11px;
    margin-top: 6px;
  }
  .ops-plan {
    margin-top: 8px;
    font-size: 12px;
  }
  .ops-page .ops-risk p {
    font-size: 12px;
    margin-top: 6px;
  }
  .ops-text-button {
    font-size: 12px !important;
  }
  .ops-section-heading {
    margin-top: 12px;
    gap: 8px;
  }
  .ops-section-heading h2 {
    font-size: 18px;
  }
  .ops-section-heading .ops-primary {
    width: auto;
    padding: 10px 12px;
    font-size: 13px;
  }
  .ops-card {
    padding: 12px;
    gap: 10px;
  }
  .ops-card-copy strong {
    font-size: 14px;
    margin-bottom: 3px;
  }
  .ops-card-copy span, .ops-card-copy small {
    font-size: 12px;
    line-height: 1.4;
  }
  .ops-card-end {
    flex-direction: column;
    gap: 5px;
    align-items: flex-end;
  }
  .ops-card-end b {
    font-size: 12px;
  }
  .ops-icon {
    flex-basis: 32px;
    height: 32px;
    font-size: 20px;
    border-radius: 10px;
  }
  .ops-state {
    padding: 20px 14px;
    font-size: 14px;
  }
  .ops-backdrop {
    padding: 0;
    align-items: flex-end;
  }
  .ops-dialog {
    border-radius: 22px 22px 0 0;
    max-height: 92dvh;
    padding: 22px 16px max(22px, env(safe-area-inset-bottom));
  }
  .ops-method {
    font-size: 13px;
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/OperationsDayPage/OperationsDayPage.scss"],"names":[],"mappings":"AAAA;EAAY,iBAAA;EAAmB,cAAA;EAAgB,uBAAA;EAAyB,cAAA;AAKxE;;AAJyB;EAAY,wCAAA;AAQrC;AARiF;EAAS,aAAA;EAAe,eAAA;AAYzG;AAZ4H;EAAkB,YAAA;EAAa,mBAAA;AAgB3J;AAhBkL;EAAwC,0BAAA;EAA4B,mBAAA;AAoBtP;;AAnBA;EAAyB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,mBAAA;AA2BxG;AA3B6H;EAAK,eAAA;EAAiB,mCAAA;EAAqC,iBAAA;AAgCxL;AAhC6M;EAAI,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAsC7P;;AArCA;EAAY,cAAA;EAAgB,qBAAA;EAAuB,eAAA;AA2CnD;;AA1CA;EAA2B,cAAA;EAAgB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,cAAA;EAAgB,0BAAA;AAqD1I;;AApDA;EAAY,aAAA;EAAe,gDAAA;EAAkD,SAAA;AA0D7E;;AAzDA;EAAuB,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,iBAAA;AAiEpG;;AAhEA;EAAe,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAuB,kBAAA;AAyEpH;;AAxEA;EAAa,cAAA;EAAgB,mCAAA;EAAqC,iBAAA;EAAmB,sBAAA;EAAuB,uBAAA;AAgF5G;;AA/EA;EAAyB,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;AAqF7D;;AApFA;EAAa,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;AA+FlJ;AA/FmK;EAAa,cAAA;EAAgB,mBAAA;AAmGhM;;AAlGA;EAAY,aAAA;EAAe,8BAAA;EAAgC,eAAA;EAAiB,YAAA;EAAc,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;AA4G/H;;AA3GA;EAAgB,WAAA;EAAa,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;AAkHtE;AAlHwF;EAAO,cAAA;EAAgB,YAAA;EAAc,mBAAA;EAAqB,sBAAA;AAwHlJ;;AAvHA;EAAsB,mBAAA;EAAqB,qBAAA;AA4H3C;AA5HkE;EAAI,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAmI1I;;AAlIA;EAAmB,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,SAAA;EAAW,uBAAA;EAAyB,cAAA;EAAgB,0BAAA;EAA4B,UAAA;EAAY,0BAAA;EAA4B,0BAAA;AA+IxM;;AA9IA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;AAqJpE;;AApJA;EAA0B,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;AA6J7H;;AA5JA;EAAa,cAAA;EAAgB,mBAAA;AAiK7B;;AAhKA;EAAuB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,kBAAA;AAwKtG;AAxK0H;EAAK,eAAA;EAAiB,SAAA;AA4KhJ;AA5K2J;EAAO,cAAA;EAAgB,gBAAA;AAgLlL;AAhLwM;EAAe,cAAA;AAmLvN;;AAlLA;EAA+B,oBAAA;EAAsB,uBAAA;EAAyB,mBAAA;EAAqB,kBAAA;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAAqB,aAAA;EAAe,eAAA;EAAiB,qBAAA;EAAuB,SAAA;EAAW,gBAAA;AAiMpP;;AAhMA;EAAe,mBAAA;EAAqB,YAAA;AAqMpC;;AApMA;EAAiB,mBAAA;EAAqB,cAAA;AAyMtC;;AAxMA;EAAe,aAAA;EAAe,QAAA;EAAU,cAAA;EAAgB,gBAAA;AA+MxD;AA/M0E;EAAS,cAAA;EAAgB,gBAAA;EAAkB,yBAAA;EAA2B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;AAyN3N;AAzN4O;EAAW,mBAAA;EAAqB,YAAA;EAAc,qBAAA;AA8N1R;;AA7NA;EAAY,aAAA;EAAe,QAAA;AAkO3B;;AAjOA;EAAY,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,8BAAA;AA+O5L;AA/O2N;EAAU,qBAAA;AAkPrO;;AAjPA;EAAY,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AA6PzJ;;AA5PA;EAA4B,mBAAA;EAAqB,cAAA;AAiQjD;;AAhQA;EAA8B,mBAAA;EAAqB,cAAA;AAqQnD;;AApQA;EAAiB,SAAA;EAAS,YAAA;AAyQ1B;AAzQwC;EAAS,cAAA;EAAgB,eAAA;EAAiB,kBAAA;AA8QlF;AA9QwG;EAAc,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,uBAAA;AAqRzL;;AApRA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,SAAA;AA0RpD;AA1R+D;EAAI,eAAA;EAAiB,mBAAA;AA8RpF;AA9R2G;EAAS,cAAA;EAAgB,eAAA;AAkSpI;;AAjSA;EAAa,kBAAA;EAAoB,0BAAA;EAA4B,mBAAA;EAAqB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;EAAgB,gBAAA;AA2S3I;;AA1SA;EAAgB,eAAA;EAAiB,QAAA;EAAU,cAAA;EAAgB,aAAA;EAAe,uBAAA;EAAyB,mBAAA;EAAqB,aAAA;EAAe,iCAAA;AAqTvI;;AApTA;EAAkE,QAAA;AAwTlE;AAxT4E;EAAQ,SAAA;EAAS,YAAA;EAAc,sBAAA;EAAwB,oBAAA;AA8TnI;AA9T2J;EAAqB,WAAA;EAAa,YAAA;EAAc,sBAAA;EAAwB,SAAA;AAoUnO;;AAnUA;EAAc,WAAA;EAAa,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;EAAgB,gBAAA;EAAkB,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,6CAAA;AA+UtJ;AA/UyL;EAAS,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,mBAAA;AAsVjR;AAtVsS;EAAK,SAAA;EAAW,eAAA;AA0VtT;AA1V2U;EAAI,gBAAA;AA6V/U;AA7VmW;EAAmB,eAAA;AAgWtX;AAhWyY;EAAmB,cAAA;AAmW5Z;;AAlWA;EAAe,aAAA;EAAe,eAAA;EAAiB,SAAA;EAAW,cAAA;AAyW1D;;AAxWA;EAAkB,6BAAA;EAA+B,gBAAA;EAAkB,gBAAA;AA8WnE;AA9WqF;EAAU,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,cAAA;AAoX9J;AApX8K;EAAI,cAAA;EAAgB,aAAA;AAwXlM;AAxXmN;EAAe,gBAAA;AA2XlO;;AA1XA;EAAc,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;AAqYjK;;AApYA;EAAc,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,aAAA;EAAe,mBAAA;EAAqB,mBAAA;AA6Y5G;AA7YiI;EAAK,cAAA;AAgZtI;AAhZwJ;EAAK,SAAA;EAAW,iBAAA;AAoZxK;;AAnZA;EACE;IAAY,uBAAA;EAuZZ;EAtZA;IAAyB,mBAAA;EAyZzB;EAzZ8C;IAAK,iCAAA;EA4ZnD;EA5ZwF;IAAI,eAAA;EA+Z5F;EA9ZA;IAAY,SAAA;EAiaZ;EAhaA;IAAuB,aAAA;IAAe,mBAAA;EAoatC;EAnaA;IAAe,kBAAA;IAAoB,eAAA;EAuanC;EAtaA;IAAa,mCAAA;EAyab;EAxaA;IAAyB,eAAA;EA2azB;EA1aA;IAAa,eAAA;IAAiB,eAAA;EA8a9B;EA7aA;IAAY,eAAA;IAAiB,eAAA;EAib7B;EAhbA;IAAwB,eAAA;IAAiB,eAAA;EAobzC;EAnbA;IAAmB,0BAAA;EAsbnB;EArbA;IAAuB,gBAAA;IAAkB,QAAA;EAybzC;EAzbmD;IAAK,eAAA;EA4bxD;EA5b2E;IAAe,WAAA;IAAa,kBAAA;IAAoB,eAAA;EAic3H;EAhcA;IAAY,aAAA;IAAe,SAAA;EAoc3B;EAncA;IAAwB,eAAA;IAAiB,kBAAA;EAuczC;EAtcA;IAA4C,eAAA;IAAiB,gBAAA;EA0c7D;EAzcA;IAAgB,sBAAA;IAAwB,QAAA;IAAU,qBAAA;EA8clD;EA9cyE;IAAI,eAAA;EAid7E;EAhdA;IAAY,gBAAA;IAAkB,YAAA;IAAc,eAAA;IAAiB,mBAAA;EAsd7D;EArdA;IAAa,kBAAA;IAAoB,eAAA;EAydjC;EAxdA;IAAgB,UAAA;IAAY,qBAAA;EA4d5B;EA3dA;IAAc,4BAAA;IAA8B,iBAAA;IAAmB,yDAAA;EAge/D;EA/dA;IAAc,eAAA;IAAiB,aAAA;EAme/B;AACF","sourcesContent":[".ops-page { max-width: 1080px; margin: 0 auto; padding: 26px 20px 60px; color: #232137; }\n.ops-page, .ops-dialog { button, a { -webkit-tap-highlight-color: transparent; } button { font: inherit; cursor: pointer; } button:disabled { opacity: .5; cursor: not-allowed; } button:focus-visible, a:focus-visible { outline: 3px solid #596cf0; outline-offset: 3px; } }\n.ops-page .ops-heading { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 16px; h1 { margin: 0 0 4px; font-size: clamp(22px, 2.4vw, 32px); line-height: 1.15; } p { margin: 0; color: #6f7890; font-size: 13px; line-height: 1.4; } }\n.ops-back { color: #6f7890; text-decoration: none; font-size: 14px; }\n.ops-refresh, .ops-close { flex: 0 0 auto; border: 0; border-radius: 50%; width: 44px; height: 44px; background: #f0f2f6; color: #232137; font-size: 28px !important; }\n.ops-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }\n.ops-hero, .ops-risk { min-width: 0; border: 1px solid #e4e8ed; border-radius: 18px; padding: 18px; background: white; }\n.ops-eyebrow { color: #6f7890; font-size: 11px; line-height: 1.4; text-transform: uppercase; letter-spacing: .04em; margin-bottom: 8px; }\n.ops-money { display: block; font-size: clamp(24px, 2.8vw, 32px); line-height: 1.15; letter-spacing: -.5px; overflow-wrap: anywhere; }\n.ops-money-unavailable { font-size: 16px; line-height: 1.35; letter-spacing: 0; }\n.ops-trend { display: inline-block; color: #187449; background: #eef9f2; font-size: 12px; line-height: 1.4; padding: 3px 6px; border-radius: 6px; margin-top: 8px; &.negative { color: #b21d38; background: #fff0f2; } }\n.ops-plan { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 4px 8px; margin: 12px 0 6px; font-size: 13px; line-height: 1.4; }\n.ops-progress { height: 5px; background: #edf0f3; border-radius: 5px; overflow: hidden; span { display: block; height: 100%; background: #e72f44; border-radius: inherit; } }\n.ops-page .ops-risk { background: #fff5f6; border-color: #f8dde2; p { color: #6f7890; font-size: 13px; line-height: 1.4; margin: 8px 0 0; max-width: 360px; } }\n.ops-text-button { display: inline-flex; align-items: center; min-height: 44px; border: 0; background: transparent; color: #b61b36; font-size: 13px !important; padding: 0; text-decoration: underline; text-underline-offset: 3px; }\n.ops-freshness { color: #6f7890; font-size: 11px; line-height: 1.4; margin: 8px 0 12px; }\n.ops-source, .ops-error { background: #fff7e5; border-radius: 12px; padding: 12px 16px; margin-bottom: 8px; font-size: 14px; line-height: 1.5; }\n.ops-error { color: #a71933; background: #fff0f2; }\n.ops-section-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin: 16px 0 8px; h2 { font-size: 20px; margin: 0; span { color: #6f7890; margin-left: 5px; } } .ops-primary { flex: 0 0 auto; } }\n.ops-primary, .ops-secondary { display: inline-flex; justify-content: center; align-items: center; text-align: center; padding: 12px 18px; min-height: 44px; border-radius: 12px; font: inherit; font-size: 14px; text-decoration: none; border: 0; line-height: 1.3; }\n.ops-primary { background: #e72f44; color: white; }\n.ops-secondary { background: #f0f2f6; color: #232137; }\n.ops-filters { display: flex; gap: 6px; overflow: auto; padding: 0 0 8px; button { flex: 0 0 auto; min-height: 44px; border: 1px solid #e4e8ed; background: white; color: #6f7890; border-radius: 12px; padding: 8px 12px; font-size: 13px; &.active { background: #232137; color: white; border-color: #232137; } } }\n.ops-list { display: grid; gap: 8px; }\n.ops-card { width: 100%; display: flex; align-items: center; gap: 16px; text-align: left; padding: 20px; border: 1px solid #e4e8ed; border-radius: 18px; background: white; color: #232137; transition: border-color .15s; &:hover { border-color: #e72f44; } }\n.ops-icon { display: grid; place-items: center; flex: 0 0 44px; height: 44px; border-radius: 14px; background: #fff0f2; color: #ba1c39; font-size: 24px; font-weight: bold; }\n.ops-card-shift .ops-icon { background: #fff4db; color: #936500; }\n.ops-card-support .ops-icon { background: #edf0ff; color: #4454b4; }\n.ops-card-copy { flex: 1; min-width: 0; strong { display: block; font-size: 16px; margin-bottom: 5px; } span, small { display: block; font-size: 13px; line-height: 1.5; color: #6f7890; overflow-wrap: anywhere; } }\n.ops-card-end { display: flex; align-items: center; gap: 16px; b { font-size: 14px; white-space: nowrap; } > span { color: #6f7890; font-size: 25px; } }\n.ops-state { padding: 36px 20px; border: 1px dashed #dce1e8; border-radius: 18px; text-align: center; background: #fafbfd; color: #6f7890; line-height: 1.5; }\n.ops-backdrop { position: fixed; inset: 0; z-index: 11000; display: flex; justify-content: center; align-items: center; padding: 20px; background: #0d263f66; }\n.ops-dialog .timetable-input-group:not(.timetable-checkbox-row) { gap: 8px; label { flex: 1; min-width: 0; flex-direction: column; align-items: stretch; } input[type=\"time\"] { width: 100%; min-width: 0; box-sizing: border-box; margin: 0; } }\n.ops-dialog { width: 100%; max-width: 780px; max-height: 90dvh; overflow: auto; background: #fff; color: #232137; padding: 26px; border-radius: 24px; box-shadow: 0 24px 80px #0d263f33; header { display: flex; justify-content: space-between; align-items: center; gap: 14px; margin-bottom: 18px; h2 { margin: 0; font-size: 23px; } } p { line-height: 1.6; } .ops-detail-lead { font-size: 19px; } .ops-detail-risk { color: #b61b36; } }\n.ops-actions { display: flex; flex-wrap: wrap; gap: 10px; margin: 18px 0; }\n.ops-candidates { border-top: 1px solid #e4e8ed; margin-top: 24px; padding-top: 8px; article { border: 1px solid #e4e8ed; border-radius: 16px; padding: 16px; margin: 12px 0; p { color: #6f7890; margin: 8px 0; } .ops-actions { margin-bottom: 0; } } }\n.ops-review { display: flex; align-items: center; justify-content: space-between; gap: 14px; border-top: 1px solid #e4e8ed; margin-top: 24px; padding-top: 18px; color: #6f7890; }\n.ops-method { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; padding: 18px; border-radius: 14px; background: #f7f9fa; dt { color: #6f7890; } dd { margin: 0; text-align: right; } }\n@media (max-width: 620px) {\n  .ops-page { padding: 20px 14px 40px; }\n  .ops-page .ops-heading { margin-bottom: 12px; h1 { font-size: clamp(21px, 6vw, 26px); } p { font-size: 12px; } }\n  .ops-grid { gap: 10px; }\n  .ops-hero, .ops-risk { padding: 14px; border-radius: 16px; }\n  .ops-eyebrow { margin-bottom: 6px; font-size: 10px; }\n  .ops-money { font-size: clamp(21px, 6.4vw, 26px); }\n  .ops-money-unavailable { font-size: 16px; }\n  .ops-trend { font-size: 11px; margin-top: 6px; }\n  .ops-plan { margin-top: 8px; font-size: 12px; }\n  .ops-page .ops-risk p { font-size: 12px; margin-top: 6px; }\n  .ops-text-button { font-size: 12px !important; }\n  .ops-section-heading { margin-top: 12px; gap: 8px; h2 { font-size: 18px; } .ops-primary { width: auto; padding: 10px 12px; font-size: 13px; } }\n  .ops-card { padding: 12px; gap: 10px; }\n  .ops-card-copy strong { font-size: 14px; margin-bottom: 3px; }\n  .ops-card-copy span, .ops-card-copy small { font-size: 12px; line-height: 1.4; }\n  .ops-card-end { flex-direction: column; gap: 5px; align-items: flex-end; b { font-size: 12px; } }\n  .ops-icon { flex-basis: 32px; height: 32px; font-size: 20px; border-radius: 10px; }\n  .ops-state { padding: 20px 14px; font-size: 14px; }\n  .ops-backdrop { padding: 0; align-items: flex-end; }\n  .ops-dialog { border-radius: 22px 22px 0 0; max-height: 92dvh; padding: 22px 16px max(22px, env(safe-area-inset-bottom)); }\n  .ops-method { font-size: 13px; padding: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
